import { render, staticRenderFns } from "./personal-information-form.vue?vue&type=template&id=3a2bba54&"
import script from "./personal-information-form.vue?vue&type=script&lang=js&"
export * from "./personal-information-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports